import axios from 'axios';
import API from "../config/API";
import siteSetting from "../config/env";

export const leaveService = {
    createLeave,
    getLeaves,
    getLeave,
    updateLeave: editLeave,
    deleteLeave,
    affectedBookings
};

// Read-only: the bookings this leave would land on, before it's saved.
// Same body as createLeave. Writes nothing.
function affectedBookings(params) {
    let headers = {
        'Content-Type' : 'application/json',
        'Authorization': 'Bearer '+localStorage.getItem('accessToken'),
    }
    const { hairdresserId, ...body } = params;
    return axios.post(siteSetting.api.v2 + "hairdresser/" + hairdresserId + '/holidays/affected-bookings', body, {headers: headers})
}


function createLeave(params) {
    let headers = {
        'Content-Type' : 'application/json',
        'Authorization': 'Bearer '+localStorage.getItem('accessToken'),
    }
    const { hairdresserId, ...body } = params;
    return axios.post(siteSetting.api.v2 + "hairdresser/" + hairdresserId + '/holidays', body, {headers: headers})
}

function getLeaves(params) {
    let headers = {
        'Content-Type' : 'application/json',
        'Authorization': 'Bearer '+localStorage.getItem('accessToken'),
    }
    return axios.get(siteSetting.api.v2 + "hairdresser/" + params.hairdresserId + '/holidays', {headers: headers})
}

function getLeave(leaveId, hairdresserId) {
    let headers = {
        'Content-Type' : 'application/json',
        'Authorization': 'Bearer '+localStorage.getItem('accessToken'),
    }
    const userId = hairdresserId || localStorage.getItem('userId');

    return axios.get(siteSetting.api.v2 + "hairdresser/" + userId + '/holidays/' + leaveId, {headers: headers})
}

function editLeave(leaveId, params) {
    let headers = {
        'Content-Type' : 'application/json',
        'Authorization': 'Bearer '+localStorage.getItem('accessToken'),
    }
    const { hairdresserId, ...body } = params;
    return axios.put(siteSetting.api.v2 + "hairdresser/" + hairdresserId + '/holidays/' + leaveId, body, {headers: headers})
}

function deleteLeave(leaveId, hairdresserId) {
    let headers = {
        'Content-Type' : 'application/json',
        'Authorization': 'Bearer '+localStorage.getItem('accessToken'),
    }
    const userId = hairdresserId || localStorage.getItem('userId');

    return axios.delete(siteSetting.api.v2 + "hairdresser/" + userId + '/holidays/' + leaveId, {
        headers: headers
    })
}